import { useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { GemCard } from "../gems/GemCard";
import { CategoryButtons } from "../gems/CategoryButtons";

type Category = "all" | "food" | "lodging" | "adventure";

const gems = [
  {
    id: 1,
    title: "La Table des Saveurs",
    before: "Un champ ordinaire",
    after: "Votre dîner ce soir",
    category: "food" as const,
  },
  {
    id: 2,
    title: "Cabane des Rêves",
    before: "Une forêt dense",
    after: "Votre nid douillet",
    category: "lodging" as const,
  },
  {
    id: 3,
    title: "Parcours Aventure",
    before: "Un sentier oublié",
    after: "Votre prochaine aventure",
    category: "adventure" as const,
  },
];

export const LocalGems = ({ isPro }: { isPro: boolean }) => {
  const [activeCategory, setActiveCategory] = useState<Category>("all");

  if (isPro) return null;

  const filteredGems = activeCategory === "all" 
    ? gems 
    : gems.filter(gem => gem.category === activeCategory);

  return (
    <section className="py-12 px-4 w-full overflow-x-hidden">
      <h2 className="text-3xl font-mono font-bold text-primary mb-8 text-center">
        Pépites Locales
      </h2>
      
      <CategoryButtons
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <Carousel className="max-w-4xl mx-auto">
        <CarouselContent>
          {filteredGems.map((gem) => (
            <CarouselItem key={gem.id} className="md:basis-1/2 lg:basis-1/3">
              <GemCard
                title={gem.title}
                before={gem.before}
                after={gem.after}
                category={gem.category}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </section>
  );
};
